import {OmyConst} from "../../OmyConst";
import Omy from "../../Omy";
import {isNull} from "rollup-plugin-node-builtins/src/es6/util";

export default class OTextFont extends PIXI.Text {
    constructor(text, style, canvas = null) {
        style.defaultFontFamily = style.fontFamily;
        if (style.hasOwnProperty("locCheck") ? style["locCheck"] : true)
            style.fontFamily = Omy.assets.localAssets(style.fontFamily);
        super(text, style, canvas);

        this.json = style;
        this._onKillEvent = "kill_event";
        this._onReviveEvent = "revive_event";
        this._onDestroyEvent = "destroy_event";
        this._onDownEvent = "down_event";
        this._onUpEvent = "up_event";
        this._onUpOutSideEvent = "up_out_event";
        this._onOverEvent = "over_event";
        this._onOutEvent = "out_event";
        this._onDragStartEvent = "drag_start_event";
        this._onDragStopEvent = "drag_stop_event";
        this._onDragUpdateEvent = "drag_update_event";
        this._onTextEvent = "text_update_event";
        this._onCountEvent = "count_update_event";

        this._saveVisible = true;
        if (Omy.debugMode) {
            this._isOnDebugerUpdate = true;
            Omy.addUpdater(this._updateDebug, this);
        }
        this._isUpdate = false;
        this.aa_isRegOnDebug = false;
        this.aa_debugAlign = "";
        this.aa_debugAlignV = "";
        this.aa_letterSpacing = -1;
        this._inDebug = false;
        /**         * @type {Object}         */
        this.userData = null;
        /**         * @type {Boolean}         */
        this._active = true;

        this._boundsRect = new OmyConst.Rectangle();
        this._localBoundsRect = new OmyConst.Rectangle();
        this._oX = 0;
        this._oY = 0;
        this._oWidth = 0;
        this._oHeight = 0;
        this._charCount = 0;

        /**         * @type {Array}         */
        this._externalMethodParams = null;
        /**         * @type {Function}         */
        this._externalMethod = null;
        this._isDrag = false;
        this._dragVertical = false;
        this._dragHorizontal = false;
        this._isStartDrag = false;
        this._isCheckInput = false;
        this._toUpperCase = style.hasOwnProperty("toUpperCase") ? style["toUpperCase"] : false;

        this._oType = OmyConst.OMY_TEXT_FONT;

        this._splitText = null;
        this._staticFirstText = null;
        this._staticLastText = null;
        this._textValue = text;
        this._fontEx = "pt";
        if (this.style.fontSize.split("px").length > 1) this._fontEx = "px";
        this._fontSize = Number(this.style.fontSize.split(this._fontEx)[0]);
        this._fontStyle = style.fontFamily;
        this._defaultFontStyle = style.defaultFontFamily;

        this._align = style.align || "left";
        this._alignV = style.alignV || "top";
        this.align = this._align;
        this.alignV = this._alignV;
        this._checkFontSize = style["checkFontSize"] || false;
        this._fullCheckFontSize = style["fullCheckFontSize"] || false;

        let noHaveTextSize = (!style["height"] || !style["width"]) && !this.text.length;
        if (noHaveTextSize) this.text = "0";
        this._maxWidth = style["width"] || this.width;
        this._maxHeight = style["height"] || this.height;
        if (noHaveTextSize) this.text = "";
        this._locTextConf = style["locConfig"];
        this._soundUp = null;
        this._soundOver = null;

        if (this._locTextConf) {
            if (this._locTextConf[Omy.language] && this._locTextConf[Omy.language].hasOwnProperty("toUpperCase")) this._toUpperCase = this._locTextConf[Omy.language]["toUpperCase"];
        }

        if (style["locConst"]) {
            this._isLocText = true;
            Omy.loc.addUpdate(this._updateText, this);
        } else {
            this._isLocText = false;
        }
        this._locCheck = style.hasOwnProperty("locCheck") ? style["locCheck"] : true;
        this._isLocalFont = Omy.assets.isLocalAssets(this._defaultFontStyle) && this._locCheck;
        if (this._isLocalFont && !this._isLocText) Omy.loc.addUpdate(this._updateText, this);

        this._oneLine = (style.hasOwnProperty("oneLine")) ? style["oneLine"] : true;
        if (!this._oneLine) {
            this.style.wordWrap = true;
            this.style.wordWrapWidth = this._maxWidth;
        } else {
            this.style.wordWrap = false;
            this.style.wordWrapWidth = Number.MAX_VALUE;
        }
        if (style.hasOwnProperty("fillGradientType")) {
            this.style.fillGradientType = ((style["fillGradientType"] === 1) ? PIXI.TEXT_GRADIENT.LINEAR_VERTICAL : PIXI.TEXT_GRADIENT.LINEAR_HORIZONTAL);
        }
        if (style.hasOwnProperty("resolution")) {
            this.resolution = style["resolution"];
        }
        this.roundPixels = ((style.hasOwnProperty("roundPixels")) ? style["roundPixels"] : true);

        this._splitDx = style["splitDx"] || 0;
        this._splitVector = (style["splitVector"] !== -1) ? 1 : style["splitVector"];
        /** @type {Array.<PIXI.DisplayObject>} */
        this._joinObjects = null;
        this._joinUpdatePause = true;

        this.text = this._textValue;
        this.interactChild = false;
        this._updateText();
        this._saveOnDestroy = false;
    }

    /**     * @private     */
    _updateDebug() {
        if (this.cullable) {
            this.aa_isRegOnDebug = !this.aa_isRegOnDebug;
            this.cullable = false;
        }
        if (this.aa_isRegOnDebug && !this._inDebug) {
            Omy.add.regDebugMode(this);
        } else if (!this.aa_isRegOnDebug && this._inDebug) {
            Omy.add.removeFromDebug(this);
        }
        if (this.aa_debugAlign.length) {
            this.align = this.aa_debugAlign;
            if (this._graphicOverlay) {
                this._graphicOverlay.destroy();
                this._graphicOverlay = null;
                this.drawDebugRect();
            }
            this.aa_debugAlign = "";
        }
        if (this.aa_debugAlignV.length) {
            this.alignV = this.aa_debugAlignV;
            if (this._graphicOverlay) {
                this._graphicOverlay.destroy();
                this._graphicOverlay = null;
                this.drawDebugRect();
            }
            this.aa_debugAlignV = "";
        }
        if (this.aa_letterSpacing !== -1) {
            this.style.letterSpacing = this.aa_letterSpacing;
            this.aa_letterSpacing = -1;
        }
    }

    drawDebugRect() {
        if (this._graphicOverlay) {
            this._graphicOverlay.width = Math.max(this._maxWidth, this.width);
            this._graphicOverlay.height = Math.max(this._maxHeight, this.height);
            this._graphicOverlay.rotation = this.rotation;
            this._updateDebugPosition();
        } else {
            this._graphicOverlay = new OmyConst.Graphics();
            this._graphicOverlay.position.set(this.worldX, this.worldY);
            this._graphicOverlay.beginFill(0xff3245, 0.5);
            let align = this.align || "left";
            let alignV = this.alignV || "top";
            let x = 0, y = 0;
            switch (align) {
                case "left": {
                    x = 0;
                    break;
                }
                case "center": {
                    x = -Math.max(this._maxWidth, this.width) * .5;
                    break;
                }
                case "right": {
                    x = -Math.max(this._maxWidth, this.width);
                    break;
                }
            }
            switch (alignV) {
                case "top": {
                    y = 0;
                    break;
                }
                case "middle": {
                    y = -Math.max(this._maxHeight, this.height) * .5;
                    break;
                }
                case "bottom": {
                    y = -Math.max(this._maxHeight, this.height);
                    break;
                }
            }

            this._graphicOverlay.drawRect(x, y, Math.max(this._maxWidth, this.width), Math.max(this._maxHeight, this.height));
            this._graphicOverlay.endFill();
            this._graphicOverlay.rotation = this.rotation;
        }

        Omy.stage.addChild(this._graphicOverlay);
    }

    /**     * @public     */
    removeDrawDebugRect() {
        if (this._graphicOverlay && this._graphicOverlay.parent) Omy.stage.removeChild(this._graphicOverlay);
    }

    _updateDebugPosition() {
        this._graphicOverlay.x = this.worldX;
        this._graphicOverlay.y = this.worldY;
    }

    resetCheckScale() {
        this._charCount = 0;
    }

    _updateText() {
        this._charCount = -1;
        if (this._locTextConf) {
            if (this._locTextConf[Omy.language] && this._locTextConf[Omy.language].hasOwnProperty("toUpperCase")) this._toUpperCase = this._locTextConf[Omy.language]["toUpperCase"]; else this._toUpperCase = this.json.hasOwnProperty("toUpperCase") ? this.json["toUpperCase"] : false;
        }
        this.setNewFont((this._isLocalFont) ? Omy.assets.localAssets(this._defaultFontStyle) : this._fontStyle);
    }

    /** @type {string | Array.<string> | number | Array.<number> | CanvasGradient | CanvasPattern} */
    setColor(tColor) {
        this.style.fill = tColor;
    }

    /**     * @public     */
    kill() {
        if (this.destroyed) return this;
        if (this._active) {
            this._active = false;
            if (this._isUpdate) Omy.removeUpdater(this.update, this);
            if (this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = false;
                Omy.removeUpdater(this._updateDebug, this);
            }
            if (this.omyTwinned) {
                Omy.remove.tween(this);
                delete this.omyTwinned;
            }

            if (this.input) this.input = false;
            this._saveVisible = this.visible;
            this.visible = false;
            this.renderable = false;
            this.emit(this._onKillEvent, this);
        }

        return this;
    }

    /**     * @public     */
    revive() {
        if (this.destroyed) return this;
        if (!this._active) {
            this._active = true;
            this.renderable = true;
            if (this._isUpdate) Omy.addUpdater(this.update, this);
            if (Omy.debugMode && !this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = true;
                Omy.addUpdater(this._updateDebug, this);
            }

            if (this.input) this.input = true;
            this.visible = this._saveVisible;
            this.emit(this._onReviveEvent, this);
            Omy.game.addNextTickUpdate(this._positionSplitText, this);
        }

        return this;
    }

    /**     * @public     */
    destroy(options) {
        if (this.destroyed) return this;
        options = options || {children: true, texture: false, baseTexture: false};
        this.parentGroup && Omy.remove.removeFromLayer(this);
        if (this.omyTwinned) {
            Omy.remove.tween(this);
            delete this.omyTwinned;
        }
        this._locTextConf = null;
        this.json = null;
        this._active = false;
        this.userData = null;
        this._boundsRect = null;
        this._localBoundsRect = null;
        this._isDrag = false;
        this._isStartDrag = false;
        if (this._listenMouseUp) {
            this._listenMouseUp = false;
            Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        }
        this._textValue = null;
        this._splitText = null;
        this._staticFirstText = null;
        this._staticLastText = null;
        this._eventData = null;
        this.isUpdate = false;
        if (this._isOnDebugerUpdate) {
            this._isOnDebugerUpdate = false;
            Omy.removeUpdater(this._updateDebug, this);
        }
        if (this._isLocText || this._isLocalFont) Omy.loc.removeUpdate(this._updateText, this);
        if (this.input) {
            this.input = false;
        }
        this.removeAllListeners(this._onDragStartEvent);
        this.removeAllListeners(this._onDragStopEvent);
        this.removeAllListeners(this._onDragUpdateEvent);
        this.removeAllListeners(this._onDownEvent);
        this.removeAllListeners(this._onOutEvent);
        this.removeAllListeners(this._onOverEvent);
        this.removeAllListeners(this._onUpEvent);
        this.removeAllListeners(this._onUpOutSideEvent);
        this.emit(this._onDestroyEvent, this);
        this.removeAllListeners(this._onDestroyEvent);
        this.removeAllListeners(this._onKillEvent);
        this.removeAllListeners(this._onReviveEvent);
        this.removeAllListeners(this._onTextEvent);
        this.removeAllListeners(this._onCountEvent);

        this._externalMethod = null;
        this._externalMethodParams = null;
        this.renderable = false;
        this.visible = false;
        this._soundUp = null;
        this._soundOver = null;
        if (this._joinObjects) {
            this._joinObjects.length = 0;
            this._joinObjects = null;
            Omy.removeUpdater(this._updateJoinPosition, this);
        }

        super.destroy(options);
        return this;
    }

    /**     * @public     */
    update() {
        if (this._isStartDrag) {
            if (this._eventData.global.x !== this._dragSaveX || this._eventData.global.y !== this._dragSaveY) {
                if (this._dragHorizontal) {
                    this.x = this._oX + this._eventData.global.x - this._dragSaveX;

                    if (this._oX < this._dragXMin) {
                        this.x = this._dragXMin;
                    } else if (this._oX > this._dragXMax) {
                        this.x = this._dragXMax;
                    }
                }
                if (this._dragVertical) {
                    this.y = this._oY + this._eventData.global.y - this._dragSaveY;

                    if (this._oY < this._dragYMin) {
                        this.y = this._dragYMin;
                    } else if (this._oY > this._dragYMax) {
                        this.y = this._dragYMax;
                    }
                }
                this._dragSaveX = this._eventData.global.x;
                this._dragSaveY = this._eventData.global.y;
                this.emit(this._onDragUpdateEvent, this);
                if (!Omy.mouse.isDown) this._upOutSide();
            }
        }
    }

    _down(event) {
        if (this._isDrag) {
            this._eventData = event.data;
            this._dragSaveX = this._eventData.global.x;
            this._dragSaveY = this._eventData.global.y;
            this._isStartDrag = true;
            this.emit(this._onDragStartEvent, this);
        }

        this.emit(this._onDownEvent, this);
    }

    _over() {
        this.emit(this._onOverEvent, this);
        if (this._soundOver) Omy.sound.play(this._soundOver);
    }

    _out() {
        this.emit(this._onOutEvent, this);
    }

    _upOutSide() {
        this._out();
        this.emit(this._onUpOutSideEvent, this);
    }

    _up() {
        this.emit(this._onUpEvent, this);
        if (this._soundUp) Omy.sound.play(this._soundUp);
        if (this._externalMethod != null) this._externalMethod.apply(null, this._externalMethodParams);
    }

    _globalMouseUp() {
        if (this._isDrag && this._isStartDrag) {
            this._eventData = null;
            this._isStartDrag = false;
            this.emit(this._onDragStopEvent, this);
        }
    }

    setXY(ax, ay) {
        this._oX = ax;
        this._oY = ay;
        this.position.set(ax, ay);
    }

    setSize(ax, ay) {
        this.width = ax;
        this.height = ay;
    }

    setScale(ax, ay) {
        this.scale.set(ax, ay);
    }

    setAnchor(ax, ay) {
        this.anchor.set(ax, ay);
    }

    setPivot(ax, ay) {
        this.pivot.set(ax, ay);
        this.x = this._oX + ax;
        this.y = this._oY + ay;
    }

    _checkScale() {
        if (this._locTextConf && this._locTextConf[Omy.language] && !this._graphicOverlay) {
            const fontSize = (Omy.isScreenPortrait) ? this._locTextConf[Omy.language]["v_fontSize"] || this._locTextConf[Omy.language]["fontSize"] : this._locTextConf[Omy.language]["fontSize"];
            this.style.fontSize = fontSize || String(this._fontSize) + this._fontEx;
        } else {
            this.style.fontSize = String(this._fontSize) + this._fontEx;
            let r = this.getLocalBounds();
            let maxValue = ((this._oneLine) ? this._maxWidth : this._maxHeight);
            let needParam = ((this._oneLine) ? "width" : "height");
            if (maxValue < r[needParam]) {
                let fontSize = this._fontSize;
                while (fontSize > 0) {
                    fontSize--;
                    this.style.fontSize = String(fontSize) + this._fontEx;
                    r = this.getLocalBounds();
                    if (maxValue >= r[needParam]) {
                        break;
                    }
                }
            }
            if (this._fullCheckFontSize && !this._oneLine) {
                r = this.getLocalBounds();
                maxValue = this._maxWidth;
                needParam = "width";
                if (maxValue < r[needParam]) {
                    let fontSize = this._fontSize;
                    while (fontSize > 0) {
                        fontSize--;
                        this.style.fontSize = String(fontSize) + this._fontEx;
                        r = this.getLocalBounds();
                        if (maxValue >= r[needParam]) {
                            break;
                        }
                    }
                }
            }
        }
    }

    /**
     * Change text font style and font size
     * @param {String} fontFamily
     */
    setNewFont(fontFamily) {
        if (!this.style) return;
        this._fontStyle = this.style.fontFamily = fontFamily;
        super.text = "";
        this._charCount = 0;
        this.text = this._textValue;

        if (this._graphicOverlay) {
            this._graphicOverlay.width = Math.max(this._graphicOverlay.width, this._oWidth);
            this._graphicOverlay.height = Math.max(this._graphicOverlay.height, this._oHeight);
        }
    }

    /**     * @private     */
    _positionSplitText() {
        if (this._splitText) {
            let splitTextX = 0;
            let textW = 0;
            if (this._splitVector === 1) {
                splitTextX = this._splitText.width * (this._splitText.anchor?.x || 0);
                textW = this.width * Math.abs(this.anchorX - 1);
            } else {
                splitTextX = this._splitText.width * ((this._splitText.anchor?.x || 0) - 1);
                textW = -this.width * this.anchorX;
            }
            this._splitText.x = this._oX + textW + splitTextX + this._splitVector * this._splitDx;
        }
    }

    /**
     * @param {Function}eMethod
     * @param {Array}methodParams
     */
    externalMethod(eMethod, methodParams) {
        if (!this.input) this.input = true;
        this._externalMethod = eMethod;
        this._externalMethodParams = methodParams;
    }

    boundsDragRect(rXMin = NaN, rYMin = NaN, rXMax = NaN, rYMax = NaN) {
        if (!isNaN(rXMin)) this._dragXMin = rXMin;
        if (!isNaN(rYMin)) this._dragYMin = rYMin;
        if (!isNaN(rXMax)) this._dragXMax = rXMax;
        if (!isNaN(rYMax)) this._dragYMax = rYMax;
    }

    addOver(func, context, once) {
        if (!this.input) this.input = true;
        this._addNewEvent(this._onOverEvent, func, context, once);
    }

    addOut(func, context, once) {
        if (!this.input) this.input = true;
        this._addNewEvent(this._onOutEvent, func, context, once);
    }

    addDown(func, context, once) {
        if (!this.input) this.input = true;
        this._addNewEvent(this._onDownEvent, func, context, once);
    }

    addUp(func, context, once) {
        if (!this.input) this.input = true;
        this._addNewEvent(this._onUpEvent, func, context, once);
    }

    addUpOutSide(func, context, once) {
        if (!this.input) this.input = true;
        this._addNewEvent(this._onUpOutSideEvent, func, context, once);
    }

    addDragUpdate(func, context, once) {
        this._addNewEvent(this._onDragUpdateEvent, func, context, once);
    }

    addDragStart(func, context, once) {
        this._addNewEvent(this._onDragStartEvent, func, context, once);
    }

    addDragStop(func, context, once) {
        this._addNewEvent(this._onDragStopEvent, func, context, once);
    }

    addKill(func, context, once) {
        this._addNewEvent(this._onKillEvent, func, context, once);
    }

    addRevive(func, context, once) {
        this._addNewEvent(this._onReviveEvent, func, context, once);
    }

    addDestroy(func, context, once) {
        this._addNewEvent(this._onDestroyEvent, func, context, once);
    }

    addTextUpdate(func, context, once) {
        this._addNewEvent(this._onTextEvent, func, context, once);
    }

    addCharCountUpdate(func, context, once) {
        this._addNewEvent(this._onCountEvent, func, context, once);
    }

    /**     * @private     */
    _addNewEvent(event, func, context, once = false) {
        if (once) this.once(event, func, context); else this.on(event, func, context);
    }

    removeOver(func, context) {
        this.removeListener(this._onOverEvent, func, context);
    }

    removeOut(func, context) {
        this.removeListener(this._onOutEvent, func, context);
    }

    removeDown(func, context) {
        this.removeListener(this._onDownEvent, func, context);
    }

    removeUp(func, context) {
        this.removeListener(this._onUpEvent, func, context);
    }

    removeUpOutSide(func, context) {
        this.removeListener(this._onUpOutSideEvent, func, context);
    }

    removeDragUpdate(func, context) {
        this.removeListener(this._onDragUpdateEvent, func, context);
    }

    removeDragStart(func, context) {
        this.removeListener(this._onDragStartEvent, func, context);
    }

    removeDragStop(func, context) {
        this.removeListener(this._onDragStopEvent, func, context);
    }

    removeKill(func, context) {
        this.removeListener(this._onKillEvent, func, context);
    }

    removeRevive(func, context) {
        this.removeListener(this._onReviveEvent, func, context);
    }

    removDestroy(func, context) {
        this.removeDestroy(func, context);
    }

    removeDestroy(func, context) {
        this.removeListener(this._onDestroyEvent, func, context);
    }

    removeTextUpdate(func, context) {
        this.removeListener(this._onTextEvent, func, context);
    }

    removeCharCountUpdate(func, context) {
        this.removeListener(this._onCountEvent, func, context);
    }

    /**
     * add object to join update position
     * @param {PIXI.DisplayObject} object
     */
    regJoinObjects(object) {
        if (!object) return;
        if (this._joinObjects == null) {
            this._joinObjects = [];
            this.joinUpdatePause = false;
        }
        object.joinX = object.json["joinX"] || 0;
        object.joinY = object.json["joinY"] || 0;
        this._joinObjects.push(object);
    }

    /**     * @private     */
    _updateJoinPosition() {
        if (!this._active) return;
        let i = 0;
        let o;
        while (i < this._joinObjects.length) {
            o = this._joinObjects[i++];
            if (o.active && ((o.x !== this.x + o.joinX) || (o.y !== this.y + o.joinY))) {
                o.x = this.x + o.joinX;
                o.y = this.y + o.joinY;
            }
        }
    }

//---------------------------------------
/// ACCESSOR
//--------------------------------------
    get align() {
        return this._align;
    }

    set align(value) {
        this._align = value;
        switch (value) {
            case "left":
                this.anchorX = 0;
                break;

            case "center":
                this.anchorX = .5;
                break;

            case "right":
                this.anchorX = 1;
                break;

            default:
                Omy.error("not exists value ", value);
                break;
        }
        this.style.align = value;
    }

    get alignV() {
        return this._alignV;
    }

    set alignV(value) {
        this._alignV = value;
        switch (value) {
            case "top":
                this.anchorY = 0;
                break;

            case "middle":
                this.anchorY = .5;
                break;

            case "bottom":
                this.anchorY = 1;
                break;

            default:
                Omy.error("not exists value ", value);
                break;
        }
    }

    set isUpdate(value) {
        if (!this._isUpdate && value) {
            Omy.addUpdater(this.update, this);
        } else if (this._isUpdate && !value) {
            Omy.removeUpdater(this.update, this);
        }
        this._isUpdate = value;
    }

    get isUpdate() {
        return this._isUpdate;
    }

    get active() {
        return this._active;
    }

    get scaleX() {
        return this.scale.x;
    }

    set scaleX(value) {
        this.scale.x = value;
    }

    get scaleY() {
        return this.scale.y;
    }

    set scaleY(value) {
        this.scale.y = value;
    }

    get pivotX() {
        return this.pivot.x;
    }

    set pivotX(value) {
        this.pivot.x = value;
    }

    get pivotY() {
        return this.pivot.y;
    }

    set pivotY(value) {
        this.pivot.y = value;
    }

    get anchorX() {
        return this.anchor.x;
    }

    set anchorX(value) {
        this.anchor.x = value;
    }

    get anchorY() {
        return this.anchor.y;
    }

    set anchorY(value) {
        this.anchor.y = value;
    }

    get localLeft() {
        return this._localBoundsRect.left;
    }

    get localRight() {
        return this._localBoundsRect.right;
    }

    get localTop() {
        return this._localBoundsRect.top;
    }

    get localBottom() {
        return this._localBoundsRect.bottom;
    }

    get localWidth() {
        return this._localBoundsRect.width;
    }

    get localHeight() {
        return this._localBoundsRect.height;
    }

    get globalLeft() {
        return this.getGlobalPosition().x + this.localLeft;
    }

    get globalTop() {
        return this.getGlobalPosition().y + this.localTop;
    }

    get worldX() {
        return this.getGlobalPosition().x;
    }

    get worldY() {
        return this.getGlobalPosition().y;
    }

    set text(value) {
        this._textValue = value;
        if (this._isLocText) {
            super.text = (this._toUpperCase) ? Omy.loc.getText(this._textValue).toUpperCase() : Omy.loc.getText(this._textValue);
        } else {
            super.text = (this._toUpperCase) ? this._textValue.toUpperCase() : this._textValue;
        }

        if (!isNull(this._staticFirstText)) super.text = this._staticFirstText + super.text;
        if (!isNull(this._staticLastText)) super.text = super.text + this._staticLastText;

        if (this._charCount !== super.text.length) {
            this._charCount = super.text.length;
            this.emit(this._onCountEvent);

            if (this.style && this._checkFontSize) this._checkScale();
        }
        Omy.game.addNextTickUpdate(this._positionSplitText, this);
        this.emit(this._onTextEvent);
    }

    get text() {
        return super.text;
    }

    set splitText(value) {
        this._splitText = value;
        Omy.game.addNextTickUpdate(this._positionSplitText, this);
    }

    get splitText() {
        return this._splitText;
    }

    get staticFirstText() {
        return this._staticFirstText;
    }

    set staticFirstText(value) {
        this._staticFirstText = value;
        this.text = this._textValue;
    }

    get staticLastText() {
        return this._staticLastText;
    }

    set staticLastText(value) {
        this._staticLastText = value;
        this.text = this._textValue;
    }

    /**
     * @returns {boolean}
     */
    get checkFontSize() {
        return this._checkFontSize;
    }

    /**
     * @param {boolean}value
     */
    set checkFontSize(value) {
        this._checkFontSize = value;
    }

    /**
     * @returns {boolean}
     */
    get fullCheckFontSize() {
        return this._fullCheckFontSize;
    }

    /**
     * @param {boolean}value
     */
    set fullCheckFontSize(value) {
        this._fullCheckFontSize = value;
    }

    get x() {
        this._oX = super.x;
        return this._oX;
    }

    set x(value) {
        super.x = this._oX = value;
        if (this._graphicOverlay) this._updateDebugPosition();
        this._positionSplitText();
    }

    get y() {
        this._oY = super.y;
        return this._oY;
    }

    set y(value) {
        super.y = this._oY = value;
        if (this._graphicOverlay) this._updateDebugPosition();
    }

    get height() {
        if (this._graphicOverlay) {
            return this._graphicOverlay.height;
        }
        this._oHeight = super.height;
        return this._oHeight;
    }

    set height(value) {
        if (this._graphicOverlay) {
            return this._graphicOverlay.height = value;
        }
        return super.height = this._oHeight = value;
    }

    get width() {
        if (this._graphicOverlay) {
            return this._graphicOverlay.width;
        }
        this._oWidth = super.width;
        return this._oWidth;
    }

    set width(value) {
        if (this._graphicOverlay) {
            return this._graphicOverlay.width = value;
        }
        return super.width = this._oWidth = value;
    }

    get rotation() {
        return super.rotation;
    }

    set rotation(value) {
        super.rotation = value;
        if (this._graphicOverlay) this._graphicOverlay.rotation = value;
    }

    set fontSize(value) {
        if (String(value).split(this._fontEx).length > 1) value = Number(String(value).split(this._fontEx)[0]);
        this._fontSize = value;
        if (this._checkFontSize) {
            this._checkScale();
        } else {
            if (this._locTextConf && this._locTextConf[Omy.language] && !this._graphicOverlay) {
                const fontSize = (Omy.isScreenPortrait) ? this._locTextConf[Omy.language]["v_fontSize"] || this._locTextConf[Omy.language]["fontSize"] : this._locTextConf[Omy.language]["fontSize"];
                this.style.fontSize = fontSize || String(this._fontSize) + this._fontEx;
            } else {
                this.style.fontSize = String(this._fontSize) + this._fontEx;
            }
        }

        if (this._graphicOverlay) {
            this._graphicOverlay.width = Math.max(this._graphicOverlay.width, this._oWidth);
            this._graphicOverlay.height = Math.max(this._graphicOverlay.height, this._oHeight);
        }
    }

    get fontSize() {
        return this._fontSize;
    }

    get oneLine() {
        return this._oneLine;
    }

    set oneLine(value) {
        this._oneLine = value;
        if (!this._oneLine) {
            this.style.wordWrap = true;
            this.style.wordWrapWidth = this._maxWidth;
        } else {
            this.style.wordWrap = false;
            this.style.wordWrapWidth = Number.MAX_VALUE;
        }
    }

    get oType() {
        return this._oType;
    }

    get input() {
        return this._isCheckInput;
    }

    set input(value) {
        if (this.input) {
            this.interactive = value;
        } else if (value) {
            this._isCheckInput = true;
            this.interactive = true;
            this.on("pointerdown", this._down, this);
            this.on("pointerup", this._up, this);
            this.on("pointerupoutside", this._upOutSide, this);
            this.on("pointerover", this._over, this);
            this.on("pointerout", this._out, this);
        }
    }

    set drag(value) {
        if (!this.input) this.input = true;

        if (!this._isUpdate) this.isUpdate = true;

        this._isDrag = value;
        this._listenMouseUp = value;
        (this._listenMouseUp) ? Omy.mouse.addUpHandler(this._globalMouseUp, this) : Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        this._dragVertical = true;
        this._dragHorizontal = true;
    }

    set allowHorizontalDrag(value) {
        this._dragHorizontal = value;
    }

    set allowVerticalDrag(value) {
        this._dragVertical = value;
    }

    set interactChild(value) {
        this.interactiveChildren = value;
    }

    /**
     * Set text max width
     * @param {number} value
     */
    set textMaxWidth(value) {
        this._maxWidth = value;
        if (!this._oneLine) {
            this.style.wordWrapWidth = this._maxWidth;
        }
        this.text = this._textValue;
    }

    /**
     * Set text max height
     * @param {number} value
     */
    set textMaxHeight(value) {
        this._maxHeight = value;
        this.text = this._textValue;
    }

    set soundUp(value) {
        this._soundUp = value;
    }

    set soundOver(value) {
        this._soundOver = value;
    }

    set joinUpdatePause(value) {
        if (this._joinUpdatePause !== value)
            if (value) Omy.removeUpdater(this._updateJoinPosition, this);
            else Omy.addUpdater(this._updateJoinPosition, this);
        this._joinUpdatePause = value;
    }

    get saveOnDestroy() {
        return this._saveOnDestroy;
    }

    set saveOnDestroy(value) {
        this._saveOnDestroy = value;
    }
}
